import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import {
  canonicalForPath,
  isKnownStaticPath,
  robotsForPath,
  seoForPath,
  NOT_FOUND_SEO,
} from '@/config/seo';

export default function DocumentHead() {
  const { pathname } = useLocation();
  const isNotFound = !isKnownStaticPath(pathname) && pathname !== '/';
  const seo = isNotFound ? NOT_FOUND_SEO : seoForPath(pathname);
  const robots = robotsForPath(pathname, import.meta.env.DEV, isNotFound);

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {!isNotFound && <link rel="canonical" href={canonicalForPath(pathname)} />}
      <meta name="robots" content={robots} />
    </Helmet>
  );
}
